import * as React from 'react';
import { connect } from 'react-redux';

import * as styles from './CalendlyFrame.css';
import { AscendState } from '../../ducks';

type StateProps = {
  advisorName?: string;
};

const CalendlyFrame = ({ advisorName }: StateProps) => {
  const defaultOption = '/hinten/15min';
  const calendlyOptions: { [key: string]: string } = {
    Justin: '/ascend-finance/15min',
    Jeffrey: '/jeffrey-ascend/transfer',
    Emma: '/emmafritsch/15min',
    Hinten: '/hinten/15min',
    Adam: '/adam-ascend/30min',
    Lexi: '/lexi-ascend/transfer',
    Chelsea: '/chelsea-qd4',
  };

  const advisorFirstName = !!advisorName && advisorName.split(' ')[0];
  const calendly = !!advisorFirstName
    ? calendlyOptions[advisorFirstName] || defaultOption
    : defaultOption;

  return (
    <div className={styles.iframeContainer}>
      <iframe src={`https://calendly.com${calendly}`} className={styles.iframe} />
    </div>
  );
};

const mapStateToProps = (state: AscendState) => ({
  advisorName: state.user.data.advisorName,
});

export default connect<StateProps>(mapStateToProps)(CalendlyFrame);
